import * as ACCESS_ROLES from './access-roles';
import * as USER_TEAM_IDS from './user-team-ids';

export const userHasAccessRole = (user, role) => {
  if (!user) {
    return false;
  }

  switch (role) {
    case ACCESS_ROLES.ROLE_CYBERINT:
      return user.team_id === USER_TEAM_IDS.MAIN_BRAND_NAME;

    case ACCESS_ROLES.ROLE_DEMO:
      return user.team_id === USER_TEAM_IDS.DEMO_USER_TEAM;

    case ACCESS_ROLES.ROLE_RETAIL:
      return user.team_id === USER_TEAM_IDS.RETAIL_USER_TEAM;

    case ACCESS_ROLES.ROLE_SINGTEL:
      return user.team_id === USER_TEAM_IDS.SINGTEL_MSSP_TEAM;

    case ACCESS_ROLES.ROLE_SOFTBANK:
      return user.team_id === USER_TEAM_IDS.SOFTBANK_TEAM;

    case ACCESS_ROLES.ROLE_TOYOTA:
      return user.team_id === USER_TEAM_IDS.TOYOTA_TEAM;

    case ACCESS_ROLES.ROLE_NOVARTIS:
      return user.team_id === USER_TEAM_IDS.NOVARTIS_TEAM;

    case ACCESS_ROLES.ROLE_ASOS:
      return user.team_id === ACCESS_ROLES.ROLE_ASOS;

    case ACCESS_ROLES.ROLE_BARCLAYS:
      return user.team_id === USER_TEAM_IDS.BARCLAYS_TEAM;

    case ACCESS_ROLES.ROLE_SKYSCANNER:
      return user.team_id === ACCESS_ROLES.ROLE_SKYSCANNER;

    case ACCESS_ROLES.ROLE_RSA_2019:
      return user.team_id === ACCESS_ROLES.ROLE_RSA_2019;

    default:
      return false;
  }
};
